import { Component, OnInit } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { filter } from 'rxjs/operators';
import { BeeFreeService } from '../../services/beefree.service';

@Component({
	selector: 'app-component-page-container',
	templateUrl: './component-page-container.component.html',
	styleUrls: ['./component-page-container.component.scss']
})
export class ComponentPageContainerComponent implements OnInit {
	componentType;
	showPreview = true;
	isBeeFree: boolean;

	constructor(private component: ComponentService, private beeFree: BeeFreeService) {}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		this.component.componentData.pipe(filter((data) => data !== null)).subscribe((result) => {
			this.componentType = result.config.type;
			if (this.componentType == 49 || this.componentType == 54) {
				setTimeout(() => (this.showPreview = false), 10);
			}
		});
	}
}
